/**
 * 로그인한 사용자 정보를 조회한다. `GET /app/users/{userID}`.
 *
 * 헤더의 사용자 이름 표시(`src/components/layout/Header.tsx`), 마이페이지 정보 수정 탭
 * (`src/components/my/EditUserInfoTab.tsx`), 로그인 직후 화면(`pages/login.tsx`)에서 쓴다.
 * 로그인한 본인 정보를 보는 요청이라 `axiosInstance` 를 쓴다.
 *
 * 주의: 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 */
import api from "../axiosInstance";

/**
 * @param userID 조회할 사용자 id
 * @returns 성공하면 `BaseResponse.result`(사용자 정보). 실패하면 undefined(예외를 던지지 않고 콘솔에만 남긴다).
 */
export async function fetchUserInfo(userID: string) {
  try {
    const res = await api.get(`/app/users/${userID}`);

    // 요청이 성공했을 경우 data.result 반환
    return res.data.result;
  } catch (error) {
    // 에러 발생 시 메시지 출력
    console.error("Error fetching problems:", error);
  }
}
export default fetchUserInfo;
